import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import PartnershipForm from '../../PartnershipForm'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'
import useManageDrawer from '../../../../../../hooks/formHooks/useManageDrawer'

import { updatePartnership, clearUpdatePartnership } from '../../../../../../modules/actions/partnerships'
import {
  partnershipsSelector,
  updatePartnershipIsLoadingSelector,
  updatePartnershipWasUpdatedSelector,
  updatePartnershipErrorSelector
} from '../../../../../../modules/selectors/partnerships'
import { clearAllPlatformsSingleAdAccount } from '../../../../../../modules/actions/adAccounts'

import { PARTNERSHIP_EDIT } from '../../../../../../constants/forms'
import {
  getInitialValues,
  transformValuesToBE,
  transformAdAccountsToBE,
  getValidationSchema
} from '../../PartnershipForm/fields'

const EditPartnershipForm = () => {
  const dispatch = useDispatch()

  const partnerships = useSelector(partnershipsSelector)
  const updatePartnershipWasUpdated = useSelector(updatePartnershipWasUpdatedSelector)

  const { selectedEditItemId } = useManageDrawer({ formName: PARTNERSHIP_EDIT })

  const onSubmit = useCallback(
    values => {
      dispatch(
        updatePartnership(selectedEditItemId, {
          ...transformValuesToBE(values),
          ...transformAdAccountsToBE(values)
        })
      )
    },
    [dispatch, selectedEditItemId]
  )

  const editPartnershipData = useMemo(
    () => partnerships.find(partnership => partnership.id === parseInt(selectedEditItemId)),
    [partnerships, selectedEditItemId]
  )

  const showPartnerSelector = Number(editPartnershipData['partner']) !== Number(editPartnershipData['rights_holder'])

  const initialValues = useMemo(() => {
    return getInitialValues(editPartnershipData)
  }, [editPartnershipData])

  const formik = useFormik({
    initialValues,
    validationSchema: getValidationSchema({ showPartnerSelector }),
    onSubmit,
    enableReinitialize: true
  })
  const purifiedFormik = usePurifiedFormik(formik)

  const clearEditPartnershipHandler = useCallback(() => {
    dispatch(clearUpdatePartnership())
    dispatch(clearAllPlatformsSingleAdAccount())
  }, [dispatch])

  return (
    <PartnershipForm
      formName={PARTNERSHIP_EDIT}
      formik={purifiedFormik}
      successSubmit={updatePartnershipWasUpdated}
      errorSelector={updatePartnershipErrorSelector}
      isLoadingSelector={updatePartnershipIsLoadingSelector}
      clearHandler={clearEditPartnershipHandler}
      showPartnerSelector={showPartnerSelector}
      isEditForm={true}
    />
  )
}

export default EditPartnershipForm
